import { DataType, utils } from '@easydata/core';
/**
 * Represents an aggregate function
 */
var AggrFunction = /** @class */ (function () {
    /** The default constructor. */
    function AggrFunction() {
        this.id = "";
        this.caption = "";
        this.sqlExpr = "";
        this.displayFormat = "";
        this.appliedTypes = [];
    }
    /**
     * Loads an aggregate function from its JSON representation object
     * @param aggrFunction The JSON representation object
     */
    AggrFunction.prototype.loadFromData = function (aggrFunction) {
        if (aggrFunction) {
            this.id = aggrFunction.id;
            this.caption = aggrFunction.cptn;
            this.displayFormat = aggrFunction.fmt;
            this.sqlExpr = aggrFunction.expr;
            this.appliedTypes = aggrFunction.dtypes || this.appliedTypes;
        }
    };
    AggrFunction.prototype.getAppliedTypesOrDefault = function () {
        if (this.appliedTypes.length > 0)
            return this.appliedTypes;
        if (this.id === 'SUM' || this.id === 'AVG') {
            return [DataType.Autoinc, DataType.Byte, DataType.Currency, DataType.Float, DataType.Int32,
                DataType.Int64, DataType.Word];
        }
        else if (this.id === 'MIN' || this.id === 'MAX') {
            return [DataType.Autoinc, DataType.BCD, DataType.Byte, DataType.Currency, DataType.Date, DataType.DateTime, DataType.Time,
                DataType.Float, DataType.Int32, DataType.Int64, DataType.Word];
        }
        return utils.getAllDataTypes();
    };
    return AggrFunction;
}());
export { AggrFunction };
//# sourceMappingURL=aggr_function.js.map